import { useEffect, useState } from 'react'

let hydrated = false

/**
 * False while the server's HTML is being hydrated, true ever after.
 *
 * The flag is the module's, not the component's: something mounted long after
 * the page loaded -- a panel opened by a click -- is told the truth on its very
 * first render, rather than rendering the server's fallback for a frame and
 * correcting itself in an effect.
 */
export function useHydrated(): boolean {
  const [value, setValue] = useState(hydrated)

  useEffect(() => {
    hydrated = true
    setValue(true)
  }, [])

  return value
}

/**
 * For an entry that renders from scratch rather than hydrating the server's
 * HTML. There is nothing to wait for then, so the very first render is told the
 * truth as well -- otherwise every translated value is blank for a frame on
 * each full page load.
 */
export function markHydrated(): void {
  hydrated = true
}
